import { ErrorResponse, ServiceResponse, ZipCode } from '@bzbs/react-api-client';
import { create } from 'zustand';
import { useBuzzebeesAppStore } from './buzzebeess-app.store';

export type ZipcodeState = {
  data: ZipCode[];
  isLoading: boolean;
  error: ErrorResponse | null;
};

export type ZipcodeActions = {
  fetchData: (zipcode: string) => Promise<ServiceResponse<ZipCode>>;
  clear: () => void;
};

export type ZipcodeStore = ZipcodeState & ZipcodeActions;

export const useZipcodeStore = create<ZipcodeStore>((set) => {
  return {
      data: [],
    isLoading: false,
    error: null,

    fetchData: async (zipcode: string) => {
      const bzbsService = useBuzzebeesAppStore.getState().bzbsService;
      if (!bzbsService) {
        return { type: 'client-error', message: 'Service not configured' } as ServiceResponse<ZipCode>;
      }
      const response = await bzbsService.addressApi.zipCodes({ zipCode: zipcode });
      if (response.type === 'success') {
        set({ data: response.model });
      } else {
        set({ error: response });
      }
      return response;
    },

    clear: () => {
      set({
        data: [],
        isLoading: false,
        error: null,
      });
    },
  };
});
